export default __webpack_public_path__ + "static/media/Chiara_Chiesa_AHV_In_Moms_We_Trust.90cee207.jpg";